var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { VehicleFormattedPrice } from '@bytebrand/fe-ui-core-autobahn/compat';
import { Button } from '@bytebrand/fe-ui-core-autobahn/ui';
import { IconSVG } from '@bytebrand/fe-ui-core-autobahn/iconsvg';
import classnames from 'classnames';
import { Visible } from 'react-grid-system';
import { supportPhoneLink } from '../../../framework/constants/app';
import OfferRequestButtonWrapper from '../OfferRequestModals/OfferRequestButtonWrapper';
import SvgDealerCheckIcon from '../../ui/SVG/DealerCheckIcon';
import OfferBlock from '../../ui/VehicleDetailed/OfferBlock/OfferBlock';
import { offers } from '@bytebrand/fe-ui-core-autobahn/constants';
import { getFormattedPrice } from '@bytebrand/fe-ui-core-autobahn/utils';
import styles from './OfferModal.styl';
let OfferModal = class OfferModal extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "onClose", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event) => {
                const { hideModal } = this.props;
                event.stopPropagation();
                event.nativeEvent.stopImmediatePropagation();
                hideModal('OFFER_MODAL');
            }
        });
        Object.defineProperty(this, "onSliderChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (onChange, name) => (value) => {
                onChange(value, name);
            }
        });
        Object.defineProperty(this, "renderHeader", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { t, priceTabActiveIndex } = this.props;
                const offerName = offers[priceTabActiveIndex].name;
                return (React.createElement("header", { className: styles.header },
                    React.createElement(IconSVG, { name: 'closeIcon', className: styles.deleteButton, onClick: this.onClose }),
                    React.createElement("h2", { className: styles.title }, t(`modals:financing.${offerName}Details`))));
            }
        });
        Object.defineProperty(this, "renderMonthlyInstallment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (finMonthlyRate, oldMonthlyInstallment, isStrikeShown) => {
                const { t, vehicleMake, vehicleModel, vehicleSubModel, vehicleOption, priceTabActiveIndex } = this.props;
                const vatRate = 19;
                return (React.createElement("div", { className: styles.carInfoWrap },
                    React.createElement("div", { className: styles.carName },
                        React.createElement("span", { className: styles.carModel },
                            vehicleMake,
                            " ",
                            vehicleModel),
                        React.createElement("span", { className: styles.carSubModel }, vehicleSubModel),
                        React.createElement("span", { className: styles.carOption }, vehicleOption)),
                    React.createElement("div", { className: styles.monthlyInstallmentWrapper },
                        React.createElement("div", { className: styles.oldFinancingPriceWrapper },
                            isStrikeShown ? (React.createElement(React.Fragment, null,
                                React.createElement("span", { className: styles.financingUnits },
                                    t('modals:financing.insteadOf'),
                                    "\u00A0"),
                                React.createElement(VehicleFormattedPrice, { isOld: true, price: oldMonthlyInstallment, numbersAfterDot: 0, disableStyles: true, className: styles.oldMonthlyInstallment, unitClassName: styles.oldMonthlyInstallmentUnit }))) : null,
                            React.createElement("span", { className: styles.financingMonthly },
                                t('modals:financing.monthly'),
                                isStrikeShown ? React.createElement("br", null) : '')),
                        React.createElement("div", { className: styles.currentPriceWrap },
                            React.createElement("span", { className: styles.prefixPrice }, t(`sidebar.financingBlock.prefixPrice`)),
                            React.createElement(VehicleFormattedPrice, { price: finMonthlyRate, numbersAfterDot: 0, className: styles.monthlyInstallment, disableStyles: true, unitClassName: styles.monthlyInstallmentUnit, postfix: priceTabActiveIndex === 0 ? '3' : '1,3', postfixClassName: styles.postfix })))));
            }
        });
        Object.defineProperty(this, "renderOfferBlock", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (financingConfig) => {
                const { t, vehicleId, financingStore: { setCommonUserConfig, getMaxFinancingFirstInstallment }, priceTabActiveIndex } = this.props;
                const offerBlockProps = {
                    t,
                    vehicleId,
                    setCommonUserConfig,
                    financingConfig,
                    priceTabIndex: priceTabActiveIndex,
                    componentType: 'main',
                    maxFinancingFirstInstallment: getMaxFinancingFirstInstallment(vehicleId)
                };
                return (React.createElement(OfferBlock, { ...offerBlockProps }));
            }
        });
        Object.defineProperty(this, "renderDetailsSection", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (financingConfig) => {
                const { t, priceTabActiveIndex } = this.props;
                const offerName = offers[priceTabActiveIndex].name;
                const offerConfig = financingConfig[offerName];
                const financialInstitution = offerConfig.financialInstitution;
                const values = Object.keys(offerConfig).reduce((acc, key) => {
                    acc[key] = getFormattedPrice(offerConfig[key], '$,.2f');
                    return acc;
                }, {}); // eslint-disable-line
                return (React.createElement("div", { className: styles.detailsSection },
                    React.createElement("em", null,
                        React.createElement("sup", null, "3 "),
                        t('modals:financing.details', values)),
                    React.createElement("br", null),
                    React.createElement("span", null, t('modals:financing.info', { financialInstitution }))));
            }
        });
        Object.defineProperty(this, "renderTakeOverButton", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { t, dealerId = null, financingStore, vehicleId } = this.props;
                const financingConfig = financingStore.getUserConfig(vehicleId);
                const { common: { currentSalesPrice } } = financingConfig;
                return (React.createElement("div", { className: styles.buttonSection },
                    React.createElement(OfferRequestButtonWrapper, { carId: vehicleId, carPrice: currentSalesPrice, dealerId: dealerId }, (onClick, isOfferRequested, hasCheckout, isAuthorized, isLoading) => {
                        const offerButtonClassName = classnames(styles.controlButton, styles.offerButtonGet, { [styles.offerButtonSuccess]: isOfferRequested });
                        return (React.createElement(Button, { variant: 'filled', className: offerButtonClassName, onClick: onClick, disabled: isLoading }, isLoading ? React.createElement("span", { className: 'auth-spinner', style: { width: 18, height: 18, borderWidth: 2 } }) : React.createElement(React.Fragment, null,
                            isOfferRequested
                                ? null
                                : React.createElement(IconSVG, { name: 'whiteEnvelope', customDimensions: true, className: styles.envelopeIcon }),
                            isOfferRequested ? React.createElement(SvgDealerCheckIcon, { className: styles.checkIcon }) : null,
                            isOfferRequested ? t('modals:financing.successfullyRequested') : t('modals:financing.requestOffer'))));
                    }),
                    React.createElement(Visible, { xs: true, sm: true, md: true },
                        React.createElement("a", { color: 'primary', href: `tel:${supportPhoneLink}`, className: classnames(styles.takeOverButton, styles.phoneButton) },
                            React.createElement(IconSVG, { name: 'popoverPhone', className: styles.phoneIcon, customDimensions: true }),
                            t('modals:financing.callUp')))));
            }
        });
    }
    render() {
        const { financingStore, vehicleId, priceTabActiveIndex } = this.props;
        const financingConfig = financingStore.getUserConfig(vehicleId);
        const offerName = offers[priceTabActiveIndex].name;
        const { common: { isStrikeShown }, [offerName]: { oldMonthlyInstallment, monthlyInstallment } } = financingConfig;
        return (React.createElement("div", { className: styles.offerModal },
            this.renderHeader(),
            this.renderMonthlyInstallment(monthlyInstallment, oldMonthlyInstallment, isStrikeShown),
            this.renderOfferBlock(financingConfig),
            this.renderTakeOverButton(),
            this.renderDetailsSection(financingConfig)));
    }
};
Object.defineProperty(OfferModal, "defaultProps", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: {
        financingConfig: {}
    }
});
OfferModal = __decorate([
    inject('financingStore'),
    observer
], OfferModal);
export default OfferModal;
